// extracted by mini-css-extract-plugin
module.exports = {"box":"haushaltsrechnung_box__2gTEI","wrapper":"haushaltsrechnung_wrapper__2EQBa"};